/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = function _default(array, _ref) {
  var skip = _ref.skip,
    limit = _ref.limit;
  return array.slice(skip, skip + limit);
};
exports.default = _default;